export enum AllowedDeliveryChannel {
  undefined = 0,
  email = 1,
  sms = 2,
  // tslint:disable-next-line:no-bitwise
  emailAndSms = email | sms,
  qr = 64,
  hyperLink = 128,
  all = 16383
}

export enum PermissionTypeDto {
  Account = "Account",
  AdvancedTools = "AdvancedTools",
  AppsShortUrlsAndQrs = "AppsShortUrlsAndQrs",
  AppsSettings = "AppsSettings",
  BulkCreate = "BulkCreate",
  BulkDelete = "BulkDelete",
  BulkLinksAndQrsList = "BulkLinksAndQrsList",
  BulkView = "BulkView",
  Cfs = "Cfs",
  CfsPrint = "CfsPrint",
  CfsTerminals = "CfsTerminals",
  Cmc = "Cmc",
  CompanySettings = "CompanySettings",
  Connectors = "Connectors",
  CustomShortUrlsAndQrs = "CustomShortUrlsAndQrs",
  CustomTransactionReport = "CustomTransactionReport",
  Customers = "Customers",
  Dashboard = "Dashboard",
  Developers = "Developers", // client only property
  ExternalFeatureIframe = "ExternalFeatureIframe", // client only property
  AppActivitiesChart = "AppActivitiesChart",
  Devices = "Devices",
  DigitalScreen = "DigitalScreen",
  DigitalScreensDashboard = "DigitalScreensDashboard",
  EngagementAttempts = "EngagementAttempts",
  ExternalContacts = "ExternalContacts",
  IssueCouponWidget = "IssueCouponWidget",
  HidePoweredBySection = "HidePoweredBySection",
  Locations = "Locations",
  LocationsCreate = "LocationsCreate",
  LocationsUpdate = "LocationsUpdate",
  LocationsDelete = "LocationsDelete",
  LoyaltyProgram = "LoyaltyProgram",
  LoyaltyProgramReporting = "LoyaltyProgramReporting",
  LoyaltyProgramWidget = "LoyaltyProgramWidget",
  ManagerSettings = "ManagerSettings",
  MarketingTools = "MarketingTools",
  MyBrand = "MyBrand",
  NfcProducts = "NfcProducts",
  OutboundCampaigns = "OutboundCampaigns",
  PosActivityReport = "PosActivityReport",
  PosIntegration = "PosIntegration",
  PosIntegrationEnabled = "PosIntegrationEnabled",
  PosReceiptSettings = "PosReceiptSettings",
  PosRules = "PosRules",
  PosSettings = "PosSettings",
  PosSettingsPosModes = "PosSettingsPosModes",
  PosSettingsLoyalty = "PosSettingsLoyalty",
  PosSettingsCoupons = "PosSettingsCoupons",
  PosSettingsPosRules = "PosSettingsPosRules",
  PosSettingsSyncEditable = "PosSettingsSyncEditable",
  PricingPlanUpgrade = "PricingPlanUpgrade",
  PrintableQrCodeFlyers = "PrintableQrCodeFlyers",
  PrintReceipt = "PrintReceipt",
  Products = "Products",
  ReportingAndAnalytics = "ReportingAndAnalytics",
  SitesBuilder = "SitesBuilder",
  AutomatedCustomerJourneys = "AutomatedCustomerJourneys",
  SmsMarketing = "SmsMarketing",
  Templates = "Templates",
  ThirdPartyAnalytics = "ThirdPartyAnalytics",
  Top10SalesPersonsChart = "Top10SalesPersonsChart",
  Top20TerminalActivityChart = "Top20TerminalActivityChart",
  SmartPageChart = "SmartPageChart",
  TrackingPixel = "TrackingPixel",
  UrlsAndQrCodes = "UrlsAndQrCodes",
  Users = "Users",
  UsersCreate = "UsersCreate",
  UsersUpdate = "UsersUpdate",
  UsersDelete = "UsersDelete",
  CustomDeliveryOptions = "CustomDeliveryOptions",

  // MAPP Coupons:
  PredefinedCoupons = "PredefinedCoupons",
  DummyCoupons = "DummyCoupons",

  // DeliveryMethods
  EmailDeliveryMethod = "EmailDeliveryMethod",
  SmsDeliveryMethod = "SmsDeliveryMethod",
  QrCodeDeliveryMethod = "QrCodeDeliveryMethod",

  // One time payments
  OneTimePaymentCreditCardUrl = "OneTimePaymentCreditCardUrl",
  OneTimePaymentPayPalUrl = "OneTimePaymentPayPalUrl",
  OneTimePaymentZellePhone = "OneTimePaymentZellePhone",
  OneTimePaymentZelleEmail = "OneTimePaymentZelleEmail",
  OneTimePaymentCashAppUrl = "OneTimePaymentCashAppUrl",

  // third party integration
  AiWorkforce = "AiWorkforce", // todo: doesn't exist on backend yet
  AppointmentBooking = "AppointmentBooking",
  AppsMarketplace = "AppsMarketplace",
  Automations = "Automations", // todo: doesn't exist on backend yet
  BirthdayClub = "BirthdayClub",
  ConnectOnSocialApp = "ConnectOnSocialApp",
  Coupons = "Coupons",
  CreateVouchersAndDeals = "CreateVouchersAndDeals",
  Crm = "Crm", // todo: doesn't exist on backend yet
  CustomerSurveyBuilderApp = "CustomerSurveyBuilderApp",
  DigitalCouponsCatalogue = "DigitalCouponsCatalogue",
  ExecutiveReport = "ExecutiveReport",
  Facebook = "Facebook",
  FlowAutomation = "FlowAutomation",
  GamifiedCoupons = "GamifiedCoupons", // todo: doesn't exist on backend yet
  GoogleAnalytics = "GoogleAnalytics",
  GoogleBusinessProfile = "GoogleBusinessProfile",
  GoogleSearchConsole = "GoogleSearchConsole",
  GoogleTagManager = "GoogleTagManager",
  LaunchLandingPages = "LaunchLandingPages",
  Logout = "Logout",
  LoyaltyProgramRegisteredUsers = "LoyaltyProgramRegisteredUsers",
  LoyaltyProgramStatistics = "LoyaltyProgramStatistics",
  MobileKioskSoftware = "MobileKioskSoftware",
  MoreIntegrations = "MoreIntegrations",
  NavigateHome = "NavigateHome",
  OnlineListingsManagement = "OnlineListingsManagement",
  QuickbooksOnline = "QuickbooksOnline",
  ReferralProgram = "ReferralProgram",
  ReplytoReviewsApp = "ReplytoReviewsApp",
  ShopifyStorefront = "ShopifyStorefront",
  SingleUseUrlLinks = "SingleUseUrlLinks",
  SmsMarketingCredits = "SmsMarketingCredits",
  SmsReminders = "SmsReminders",
  UniqueCodeGenerator = "UniqueCodeGenerator",
  UnifiedReportingDashboard = "UnifiedReportingDashboard",
  VipClub = "VipClub",
  ActivitiesByLocationsChart = "ActivitiesByLocationsChart",
  ShortLinksChart = "ShortLinksChart",
  LinkToAny = "LinkToAny",
  TotalEngagementsChart = "TotalEngagementsChart",
}

export const allowedClientFeatures: PermissionTypeDto[] = [
  PermissionTypeDto.Developers,
  PermissionTypeDto.ExternalFeatureIframe,
];



export enum SubscriptionAppliance {
  Account = "Account",
  Location = "Location"
}

export enum SubscriptionPlanType {
  Onboarding = "Onboarding",
  Integration = "Integration",
  ActivationBulk = "ActivationBulk"
}

export enum SubscriptionAddonType {
  Device = "Device",
  Terminal = "Terminal",
  Printed = "Printed",
  MarketingApp = "MarketingApp",
  ExternalFeature = "ExternalFeature",
  BulkLinks = "BulkLinks",
  Feature = "Feature"
}

export enum PermissionCategoryDto {
  Core = "Core",
  DeliveryMethod = "DeliveryMethod",
  OneTimePayment = "OneTimePayment",
  PosSettingsConfiguration = "PosSettingsConfiguration"
}
